/* global angular */
( function () {
	'use strict';

	function getRoutes () {
		return [
			{
				'url' : '/templates',

				'config' : {
					'templateUrl'  : '/templates/templates/templates.html',
					'controller'   : 'Templates',
					'controllerAs' : 'vm',
					'title'        : 'Templates',
					'state'        : 'templates',

					'access' : {
						'requiredLogin' : true
					},

					'settings' : {
						'nav'     : 4,
						'content' : '<span class="icon5-template"></span> <span class="hidden-xs hidden-sm qa-nav-templates">Templates</span>'
					}
				}
			},
			{
				'url' : '/template/:id?',

				'config' : {
					'templateUrl'  : '/templates/templates-new/templates-new.html',
					'controller'   : 'NewTemplates',
					'controllerAs' : 'vm',
					'title'        : 'Template',
					'category'     : 'sub-routes',
					'state'        : 'templates',

					'access' : {
						'requiredLogin' : true
					}
				}
			},
			{
				'url' : '/template/:id?/preview',

				'config' : {
					'templateUrl'  : '/templates/templates-preview/templates-preview.html',
					'controller'   : 'TemplatesPreview',
					'controllerAs' : 'vm',
					'title'        : 'Template',
					'category'     : 'sub-routes',
					'state'        : 'templates',
					'resolve'      : { 'tplType' : angular.noop },
					'access'       : { 'requiredLogin' : true }
				}
			},
			{
				'url' : '/template/:id?/preview/draft',

				'config' : {
					'templateUrl'  : '/templates/templates-preview/templates-preview.html',
					'controller'   : 'TemplatesPreview',
					'controllerAs' : 'vm',
					'title'        : 'Template',
					'category'     : 'sub-routes',
					'state'        : 'templates',
					'access'       : { 'requiredLogin' : true },

					'resolve' : {
						'tplType' : function () {
							return 'templateDraft';
						}
					}
				}
			}
		];
	}

	function getResponse ( rejection ) {
		if ( rejection.status === 400 ) {
			return {
				'title'   : '',
				'message' : rejection.data
			};
		}

		return null;
	}

	function templateResponse () {
		return getResponse;
	}

	/* @ngInject */
	function appRun ( routehelper, tokenInterceptor ) {
		tokenInterceptor.registerResponseOverride( '/templates', {
			'getResponse' : getResponse
		} );

		routehelper.configureRoutes( getRoutes() );
	}

	angular
		.module( 'app.templates' )
		.factory( 'templateResponse', templateResponse )
		.run( appRun );
} )( );
